import React, { useState, useEffect, useRef, useCallback } from 'react';

import Bus from '../../../../assets/images/icones/1onibus.png';
import MultiBus from '../../../../assets/images/icones/3onibus.png';
import BH from '../../../../assets/images/icones/bh.png';


import { BaseComp, BaseContent, TextBody, TextContent, TextTitle, IconsContent, DefaultBox, IconImg, IconImgMulti } from './styles';

interface INavBar {

}



const NossosNumeros: React.FC<INavBar> = () => {
    const ref = useRef<HTMLDivElement>(null);
  const [counts, setCounts] = useState({ veiculo: 0, linhas: 0, cobertura: 0 });
  const targets = { veiculo: 2000, linhas: 300, cobertura: 100 };
  const [isVisible, setIsVisible] = useState(false);
  
    // Observer
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, []);
  
    const animateCounters = useCallback(() => {
    if (!isVisible) return;

    let start: number | null = null;
    const duration = 2000; // 2 segundos de animação
    const step = (timestamp: number) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);

      setCounts((prev) => ({
        veiculo: Math.floor(progress * targets.veiculo),
        linhas: Math.floor(progress * targets.linhas),
        cobertura: Math.floor(progress * targets.cobertura),
      }));

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [isVisible]);

  useEffect(() => {
    if (isVisible) {
      animateCounters();
    }
  }, [isVisible, animateCounters]);


    return (
        <BaseComp id='num' ref={ref}>
            <BaseContent>
                <TextContent>
                    <TextTitle>
                        <h1>NOSSOS NÚMEROS</h1>
                    </TextTitle>
                    <TextBody>
                        <p>
                            Somos a única empresa de mídia exterior a conseguir 100% de cobertura na cidade de Belo Horizonte com um único formato!
                        </p>
                    </TextBody>
                </TextContent>
                <IconsContent>
                    <DefaultBox>
                        <IconImgMulti src={MultiBus} />
                        <h3 className="growing-text">Linhas</h3>
                        <h1 className="growing-text">+{counts.linhas}</h1>
                    </DefaultBox>
                    <DefaultBox>
                        <IconImg src={Bus} />
                        <h3 className="growing-text">Veículos</h3>
                        <h1 className="growing-text">+{counts.veiculo}</h1>
                    </DefaultBox>
                    <DefaultBox>
                        <IconImg src={BH} />
                        <h3 className="growing-text">Cobertura BH</h3>
                        <h1 className="growing-text">{counts.cobertura}</h1>
                    </DefaultBox>
                </IconsContent>
            </BaseContent>
        </BaseComp>
    );
}

export { NossosNumeros }